/**
 * 系统管理 菜单管理
 */
<template>
  <div class="main">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>系统管理</el-breadcrumb-item>
      <el-breadcrumb-item>身份关联账号</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
        <el-form :inline="true" :model="formProInfo" class="user-search">
			
			<!-- <el-form-item label="类别">
			 <el-select size="small" v-model="formProInfo.category" placeholder="请选择">
			     <el-option label="产品推荐分类" value="1"></el-option>
				 <el-option label="活动推荐分类" value="2"></el-option>
			  </el-select>
			</el-form-item> -->
		
		 <el-form-item label="手机号" >
		   <el-input size="small" v-model="formProInfo.mobile" placeholder="输入手机号"></el-input>
		 </el-form-item>
		
			<el-button size="small" type="info" icon="el-icon-refresh-left" @click="refrea" class="refrea">重置</el-button>
            <el-button size="small" type="primary" icon="el-icon-search" @click="search" class="search">搜索</el-button>
           
          </el-form-item>
        </el-form>
		<!-- <el-button size="small" type="primary" icon="el-icon-plus" @click="add" class="add">新增</el-button> -->
        <!--列表-->
        <el-table size="small" @selection-change="selectChange" :data="proInfoList" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
          <el-table-column align="center" type="selection" width="50">
          </el-table-column>
          <el-table-column align="center" prop="accountName" label="账号名称" >
		  </el-table-column>
		  <el-table-column align="center" prop="accountPhone" label="账号手机号" >
		  </el-table-column>
		  <el-table-column align="center" prop="dealerCompany" label="经销商公司名称" >
		  </el-table-column>
		  <el-table-column align="center" prop="dealerLinkName" label="经销商联系人" >
		  </el-table-column>
		  <el-table-column align="center" prop="saleManName" label="分销商名称" >
		  </el-table-column>
		  <el-table-column align="center" prop="saleManPhone" label="分销商联系人电话" >
		  </el-table-column>
		  <el-table-column align="center" prop="zzdbName" label="驻镇代表姓名" >
		  </el-table-column>
		  <el-table-column align="center" prop="zzdbPhone" label="驻镇代表电话" >
		  </el-table-column>
		  <el-table-column align="center" prop="customerName" label="客户姓名" >
		  </el-table-column>
		  <el-table-column align="center" prop="customerPhone" label="客户电话" >
		  </el-table-column>
		  <el-table-column align="center" prop="saleDirectorName" label="销售总监姓名" >
		  </el-table-column>
		  <el-table-column align="center" prop="saleDirectorPhone" label="销售总监电话" >
		  </el-table-column>
		  <el-table-column align="center" prop="regionalDirectorName" label="区域总监姓名" >
		  </el-table-column>
		  <el-table-column align="center" prop="regionalDirectorPhone" label="区域总监电话" >
		  </el-table-column>
		  <el-table-column align="center" prop="regionalManagerName" label="区域经理电话" >
		  </el-table-column>
		  <el-table-column align="center" prop="regionalManagerPhone" label="区域总监电话" >
		  </el-table-column>
		  <el-table-column align="center" prop="systemManagerName" label="区域总监电话" >
		  </el-table-column>
		  
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        
      </div>
    </template>

    <script>
    import {
      fullSubAccountList
	  
      } from '../../api/knowledgeFun'
    import Pagination from '../../components/Pagination'

  
    import {evaluateUpload }from '@/api/auth';
    import { setCookie, getCookie, delCookie } from '../../utils/util'



    export default {
      data() {
        return {
          loading: false, //是显示加载
         
          // 请求数据参数
          formProInfo: {
            pageNum: 1,
            pageSize: 10,
            phone:''
			
          },
		  dateValue:'',
    	  proInfoList:[],
          
          // 分页参数
          pageparm: {
            currentPage: 1,
            pageSize: 10,
            total:0,
          }
        }
      },
      // 注册组件
      components: {
        Pagination
      },

      /**
       * 数据发生改变
       */
      watch: {},

      /**
       * 创建完毕
       */
      created() {
        this.getData(this.formProInfo)

      },
      mounted(){
        // document.addEventListener("paste", this.handlePaste);
      },
      beforeDestroy(){
        // document.removeEventListener("paste",this.handlePaste);
      },
      /**
       * 里面的方法只有被调用才会执行
       */
      methods: {
		  
		refrea(){
			this.formProInfo.phone=''
		},
       // 选择复选框事件
       selectChange(val) {
         this.selectdata = val
       },

        // 获取数据方法
        getData(pageparm) {
          this.loading = true
		  
          fullSubAccountList(pageparm).then(res => {
            console.log(123)
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.proInfoList = res.data
			   this.proInfoList.map((item,index)=>{
				   if(item.household==false){
					   item.household='否'
				   }else{
					   item.household='是'
				   }
				   if(item.commercial==false){
				   		item.commercial='否'
				   }else{
				   		item.commercial='是'
				   }
				   if(item.manual==false){
				   		item.manual='否'
				   }else{
				   		item.manual='是'
				   }
			   })

              // 分页赋值
              this.pageparm.currentPage = this.formProInfo.pageIndex
              this.pageparm.pageSize = this.formProInfo.pageSize
              this.pageparm.total = res.total
            }
          })
        },
        // 分页插件事件
        callFather(parm) {
          this.formProInfo.pageIndex = parm.currentPage
          this.formProInfo.pageSize = parm.pageSize
          this.getData(this.formProInfo)
        },
        //搜索事件
        search() {
          this.formProInfo.pageIndex = 1
          this.getData(this.formProInfo)
        },


      }
    }
    </script>

    <style scoped>
    .user-search {
      margin-top: 20px;
    }
    .userRole {
      width: 100%;
    }
    .main{
    	background-color: #fff;
    	padding: 30px;
    	border-radius: 10px;
		
    }
    /* .avatar-uploader{
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
    } */
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9 !important;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .el-form-item{
  	  width: 200px;
  }
  .huans{
	  width: 500px;
  }
  .el-input{
  	  width: 140px;
  }
  /deep/ .el-input--small{
  	  width: 140px;
  }
  /deep/ .el-form--inline .el-form-item__label{
	  width: 60px;
	  overflow-wrap: break-word;
	  
  }
  /deep/ .huan .el-form-item__label{
  	  line-height: 20px;
  	  
  }
  /deep/ .huans .el-form-item__label{
	  width: 80px;
  	  
  }
 /* .search{
	  position: absolute;
	  right: 0;
	  top: 68px;
  } */
  .add{
	  margin-bottom: 30px;
  }
  .el-button--small{
	margin-top: 5px;  
  }
 /* .refrea{
	  position: absolute;
	  right: 0;
	  top: 5px;
  }
 .user-search{
	  position: relative;
  } */
    </style>





// WEBPACK FOOTER //
// src/views/system/accountAssociated.vue